export enum ExternalUrlIdentifier {
  ContactUs = 0,
  EducatorReferral,
  InviteBanker,
  PlatformInstructions,
  AskAnExpert,
}
